<template>
    <div :class="classList" v-on="$listeners">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "VContainer",
    props: {
        fluid: Boolean
    },
    computed: {
        classList() {
            return "container" + (this.fluid ? "-fluid" : "");
        }
    }
};
</script>